import type { RichTextContentProps } from './types';
import { forwardRef } from 'react';
import parse from 'html-react-parser';
import { cls } from '@/utils';
import style from './RichText.module.scss';
import { RichTextDefaultArr } from '@/constants';
export type Ref = HTMLDivElement;
const RichText = forwardRef<Ref, RichTextContentProps>(({
  className,
  text,
  ...props
}, ref) => {
  const _className = cls(style.root, className);
  if (typeof text === 'undefined' || typeof text !== 'string') return null;
  if (RichTextDefaultArr.includes(text.trim())) return null;
  return <div className={_className} {...props} ref={ref}>
			{parse(text)}
		</div>;
});
export default RichText;